import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: '',
  expires_at: '',
  created_at: '',
  signedIn: false,
};

export const sessionSlice = createSlice({
  name: 'auth/token',
  initialState: initialState,
  reducers: {
    loginToken: (state, action) => {
      state.signedIn = true
      state.token = action.payload.token
      state.expires_at = action.payload.expires_at
      state.created_at = action.payload.created_at
    },
    logoutToken: () => initialState,
    updateToken: (state, action) => {
      state.token = action.payload.token
      state.expires_at = action.payload.expires_at
    },
  },
});

export const { loginToken, logoutToken, updateToken } = sessionSlice.actions;

export default sessionSlice.reducer;